import Spin from 'react-reveal/Spin';
import Jello from 'react-reveal/Jello';
import Zoom from 'react-reveal/Zoom';
import MemberOne from "../../assets/images/webp/overviewPage/memberOne.webp";
import MemberTwo from "../../assets/images/webp/overviewPage/memberTwo.webp";

import './animate.scss'


const Box = () => {

    return (

        <div className="box-container">
            <Zoom left >
                <img className="image" src={MemberOne} alt="team member" style={{ width: "380px" }} />
            </Zoom>
            <Zoom left>
                <img className="image" src={MemberTwo} alt="team member" style={{ width: "380px" }} />
            </Zoom>
        </div>

    );
};

export default function App() {
    return (
        <div className="App">
            <Box num={1} />
            <Box num={2} />
            <Box num={3} />
        </div>
    );
}